import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../../controllers/academics/academics";
import { list as academicsList } from "../../../controllers/academics/academics";
import { fetchIpAddress } from "../../../controllers/API";
import imageCompression from "browser-image-compression";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  // const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  // const [ADDEDITDATA, setAddEditSata] = useState({ group: [] });
  const [ADDEDITDATA, setAddEditSata] = useState(state ? { ...state } : { group: [] });
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [academicsPages, setAcademicsPages] = useState([]);
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  // Handle changes for group data
  const handleGroupChange = (index, field, value) => {
    const updatedGroups = [...ADDEDITDATA.group];
    updatedGroups[index][field] = value;
    setAddEditSata((prev) => ({ ...prev, group: updatedGroups }));
  };

  // Handle changes for items within a group
  const handleItemChange = (groupIndex, itemIndex, field, value) => {
    const updatedGroups = [...ADDEDITDATA.group];
    updatedGroups[groupIndex].items[itemIndex][field] = value;
    setAddEditSata((prev) => ({ ...prev, group: updatedGroups }));
  };

  // Add a new group
  // const addGroup = () => {
  //   setAddEditSata((prev) => ({
  //     ...prev,
  //     group: [
  //       ...prev.group,
  //       { name: "", items: [{ subject: "", details: "" }] },
  //     ],
  //   }));
  // };
  const addGroup = () => {
    setAddEditSata((prev) => ({
      ...prev,
      group: [...(prev.group || []), { name: "", items: [{ subject: "", details: "" }] },
      ],
    }));
  };
  // const handleAddGroup = () => {
  //   setAddEditSata((prev) => ({
  //     ...prev,
  //     group: [...(prev.group || []), { name: "", otherField: "" }] // Add a new empty group object
  //   }));
  // };
  

  // Add a new item to a group
  const addItemToGroup = (index) => {
    const updatedGroups = [...ADDEDITDATA.group];
    updatedGroups[index].items.push({ subject: "", details: "" });
    setAddEditSata((prev) => ({ ...prev, group: updatedGroups }));
  };

  // Remove a group
  const removeGroup = (index) => {
    const updatedGroups = [...ADDEDITDATA.group];
    updatedGroups.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, group: updatedGroups }));
  };

  // Remove an item from a group
  const removeItemFromGroup = (groupIndex, itemIndex) => {
    const updatedGroups = [...ADDEDITDATA.group];
    updatedGroups[groupIndex].items.splice(itemIndex, 1);
    setAddEditSata((prev) => ({ ...prev, group: updatedGroups }));
  };

  /*********************************************************
   *  This function is use to handle image
   *********************************************************/
   const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, image: "Please upload a valid image file." }));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, image: "Image must be smaller than 5MB." }));
      return;
    }

    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setImage((prev) => [...prev, newFile]);
      setError((prev) => ({ ...prev, image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file) => {
    setImage((prev) => prev.filter((img) => img.uid !== file.uid)); // Remove specific image
  };

  /*********************************************************
  *  This function is use to handle image object
  *********************************************************/
  // const handleImageChnage = (e) => {
  //   setImageList(e.fileList[0].originFileObj);
  //   setPhotosList(e.fileList)
  // }
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        board,
        title,
        content,
        page,
        group,
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("board", board);
      form.append("title", title);
      form.append("content", content);
      form.append("page", page);
      form.append("group", JSON.stringify(group));
      // if (image.length > 0) {
      //   form.append("image", image[0]?.originFileObj);
      // }
      if (image) {
        image.forEach((item, index) => {
          form.append(`image`, item.originFileObj);
        });
      }
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: "academics/curriculums/addeditdata",
          postData: form,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/academic/curriculums");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("board").trim() || form.get("board").trim() === "undefined" || form.get("board").trim() === null) {
      setError((preError) => ({
        ...preError,
        board: "Board is required",
      }));
      return false;
    }
    if (!form.get("title").trim() || form.get("title").trim() === "undefined" || form.get("title").trim() === null) {
      setError((preError) => ({
        ...preError,
        title: "Title is required",
      }));
      return false;
    }
    if (!form.get("content").trim() || form.get("content").trim() === "undefined" || form.get("content").trim() === null) {
      setError((preError) => ({
        ...preError,
        content: "Content is required",
      }));
      return false;
    }
    if (!form.get("page") || form.get("page") === "undefined" || form.get("page") === null) {
      setError((preError) => ({
        ...preError,
        page: "Page is required",
      }));
      return false;
    }
    return true;
  };


  /*********************************************************
   *  This function is used for get all academics
   *********************************************************/
  const getAcademicsPages = async () => {
    try {
      const bannerWhere = {
        type: "",
        condition: {
          status: "A"
        }
      };
      const acadPages = await academicsList(bannerWhere);
      if (acadPages.result && acadPages?.result.length > 0) {
        setAcademicsPages(acadPages.result);
      } else {
        setAcademicsPages([]);
      }
    } catch (error) {
      console.log('no pages found');
      setAcademicsPages([]);
    }
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    getAcademicsPages();
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Academics curriculums`;
  }, []);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Academics curriculums
            </h5>
          </div>
          <Link to="/academic/curriculums">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="board"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Board :{" "}
                    </label>
                    <input
                      title="Enter board"
                      placeholder="Enter board"
                      type="text"
                      name="board"
                      className="form-control store_input_field"
                      id="board"
                      value={ADDEDITDATA?.board}
                      onChange={handleChange}
                    />
                    {error.board ? (
                      <p style={{ color: "red" }}>
                        {error.board}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="title"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="title"
                      className="form-control store_input_field"
                      id="title"
                      value={ADDEDITDATA?.title}
                      onChange={handleChange}
                    />
                    {error.title ? (
                      <p style={{ color: "red" }}>
                        {error.title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Content :
                    </label>
                    <textarea
                      title="Enter content"
                      placeholder="Enter content"
                      type="text"
                      name="content"
                      className="form-control store_input_field"
                      id="content"
                      value={ADDEDITDATA?.content}
                      onChange={handleChange}
                      rows={4}
                    />
                    {error.content ? (
                      <p style={{ color: "red" }}>{error.content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="type" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Page</label>
                    <select className="form-control categories_select_tg_enter_product" name='page' id='page' onChange={handleChange}>
                      <option value="">Select page</option>
                      {academicsPages && academicsPages.map(pages => (
                        <option
                          key={pages?.slug}
                          value={pages?.slug}
                          selected={ADDEDITDATA?.page === pages?.slug ? true : false}
                        >
                          {pages?.name}
                        </option>
                      ))}
                    </select>
                    {error.page ? (<p style={{ color: "red" }}> {error.page} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                    <button type="button" onClick={addGroup} className="btn btn-primary">Add Group</button>
                  </div>
                  {ADDEDITDATA?.group?.map((group, groupIndex) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={groupIndex}>
                      <div className="row">
                        <div className="form-group col-lg-10 col-md-10 col-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Group :{" "}
                          </label>
                          <input
                            value={group.name}
                            placeholder="Group Name"
                            onChange={(e) =>
                              handleGroupChange(groupIndex, "name", e.target.value)
                            }
                            type="text"
                            // name="group"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data">
                          <button type="button" onClick={() => removeGroup(groupIndex)} className="btn btn-primary">Remove Group</button>
                        </div>
                      </div>

                      <div className="row">
                        {group?.items.map((item, itemIndex) => (
                          <>
                            <div className="form-group col-lg-5 col-md-5 col-sm-12 col-xs-12 vendor_Add_edit_data">
                              <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                                <span style={{ color: "red" }}>*</span>Subject :{" "}
                              </label>
                              <input
                                value={item.subject}
                                placeholder="Subject"
                                onChange={(e) =>
                                  handleItemChange(
                                    groupIndex,
                                    itemIndex,
                                    "subject",
                                    e.target.value
                                  )
                                }
                                type="text"
                                className="form-control store_input_field"
                              />
                            </div>
                            <div className="form-group col-lg-5 col-md-5 col-sm-12 col-xs-12 vendor_Add_edit_data">
                              <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                                <span style={{ color: "red" }}>*</span>Details :{" "}
                              </label>
                              <input
                                value={item.details}
                                placeholder="Details"
                                onChange={(e) =>
                                  handleItemChange(
                                    groupIndex,
                                    itemIndex,
                                    "details",
                                    e.target.value
                                  )
                                }
                                type="text"
                                className="form-control store_input_field"
                              />
                            </div>
                            <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                              <button type="button" onClick={() =>
                                removeItemFromGroup(groupIndex, itemIndex)
                              } className="btn btn-primary">Remove Item</button>
                            </div>
                          </>
                        ))}
                        <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                              <button type="button" onClick={() => addItemToGroup(groupIndex)} className="btn btn-primary">Add Item</button>
                            </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Images
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="3"
                    multiple={true}
                    listType="picture-card"
                    fileList={image}
                    onChange={handleImageChange}
                     beforeUpload={() => false} // Prevent automatic upload
                     onRemove={handleRemove} 
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG).
                  </p>
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
